import * as React from 'react';
import WeekStartersEnum from '../enums/WeekStartersEnum';
import Actions from '../enums/ActionsEnum';
var CalendarPropsContext = React.createContext({
    experiments: [],
    isMobile: false,
    openPopup: null,
    onEventExpanded: function () { },
    handleTimezoneChange: function () { },
    handleMonthChange: function () { },
    onCopyClick: function () { },
    onAttachmentClick: function () { },
    onLocationClick: function () { },
    onTodayClick: function () { },
    //refs
    calendarRef: {},
    todayRef: {},
    //state
    isFixedSize: true,
    timezone: '',
    isLiveSite: false,
    isDatesReturn: false,
    timeFormat: '',
    isBorderShown: true,
    error: '',
    weekStarter: WeekStartersEnum.Sunday,
    dates: {},
    isStretchable: false,
    alignment: '',
    isTimezoneShown: true,
    isTimeShown: true,
    locale: 'en',
    isTodayButtonStyleSecondary: true,
    action: Actions.NO_ACTION,
    isNextDisabled: false,
    isPrevDisabled: false,
    isShowMoreButtonStyleSecondary: false,
    isPreLoaded: false,
    wixStyles: {},
    privetEventsTitle: 'Private',
    isWeekly: false,
    isPrivateEventsShown: false,
    calendarsList: [],
    weeklyTimezone: '',
    datePickerMobileDate: {},
    // recurrenceArr: [],
    firstDay: 0,
});
export default CalendarPropsContext;
//# sourceMappingURL=calendarPropsContext.js.map